import React from "react";
import SupportContactEmbed from "../components/SupportContactEmbed";

const SupportContactPage = () => {
    return (
        <div className="max-h-[calc(100vh-100px)]">
            <div className="w-full mx-auto px-4 py-8 sm:py-12">
                <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-2 text-center">
                    Support
                </h1>
                <p className="text-gray-600 text-sm text-center sm:text-base mb-6">
                    We are here to help — contact us anytime using the form below.
                </p>
                
                    <SupportContactEmbed />
            </div>
        </div>
    );
};

export default SupportContactPage;
